import { IStepButton } from '../IComponents.js';

/**
 * BasicStepButton - Simple div-based step button
 */
export class BasicStepButton extends IStepButton {
    constructor(container, options) {
        super(container, options);
        this.active = options.active ?? false;
        this.current = false;
        this._create();
    }

    _create() {
        const { index, type = 'gate', color } = this.options;

        this.element = document.createElement('div');
        this.element.className = 'step';
        this.element.dataset.step = index;

        // Add type class
        if (type === 'accent') {
            this.element.classList.add('accent');
        } else if (type === 'slide') {
            this.element.classList.add('slide');
        }

        // Custom color
        if (color) {
            this.element.style.setProperty('--step-color', color);
        }

        // Initial state
        if (this.active) {
            this.element.classList.add('active');
        }

        // Click handler
        this.element.addEventListener('click', () => {
            this.active = !this.active;
            this.element.classList.toggle('active', this.active);
            this._emitChange(this.active);
        });

        this.container.appendChild(this.element);
    }

    getValue() {
        return this.active;
    }

    setValue(value) {
        this.active = value;
        this.element.classList.toggle('active', this.active);
    }

    isActive() {
        return this.active;
    }

    setActive(active) {
        this.setValue(active);
    }

    setCurrent(isCurrent) {
        this.current = isCurrent;
        this.element.classList.toggle('current', isCurrent);
    }
}
